import { useContext, useEffect, useState } from "react";
import { logoIcon, reviewIcon, secureIcon, selfixLogoIcon, submitIcon } from "../../assets";
import "./index.css";
import { useNavigate } from "react-router";
import ChatStore from "../../stores/ChatStore";
import CallStore from "../../stores/CallStore";
import strings from "../../localization";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import { observer } from "mobx-react";
import { DomPurifyHtml } from "../../components/DomPurifyHtml";

const reviewQuestions = [
  {
    id: 1,
    title: strings.feedback,
    question: strings.howWasYourSupportSession,
    userAnswer: "",
    rating: 0,
  },
  {
    id: 2,
    title: strings.customerExperience,
    question: strings.howWouldYouRateTheQualityOfSupportYouReceived,
    userAnswer: "",
    rating: 0,
  },
  {
    id: 3,
    title: strings.satisfacitionRating,
    question: strings.overallHowSatisfiedAreYouWithTheRemoteSupportSession,
    userAnswer: "",
    rating: 0,
  },

];

const starSvgString = `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <mask id="mask0_371_48214" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="22" height="21">
    <path d="M11.6615 2.33299C11.7127 2.2098 11.8873 2.2098 11.9385 2.33299L14.6215 8.78358C14.6431 8.83552 14.6919 8.871 14.748 8.8755L21.7119 9.4338C21.8449 9.44446 21.8988 9.61044 21.7975 9.69724L16.4917 14.2422C16.449 14.2788 16.4303 14.3362 16.4434 14.3909L18.0644 21.1866C18.0954 21.3164 17.9542 21.4189 17.8403 21.3494L11.8782 17.7078C11.8302 17.6784 11.7698 17.6784 11.7218 17.7078L5.75969 21.3494C5.64583 21.4189 5.50464 21.3164 5.5356 21.1866L7.15661 14.3909C7.16966 14.3362 7.151 14.2788 7.10828 14.2422L1.80248 9.69724C1.70115 9.61044 1.75508 9.44446 1.88808 9.4338L8.85204 8.8755C8.90811 8.871 8.95695 8.83552 8.97855 8.78358L11.6615 2.33299Z" fill="black" stroke="black"/>
  </mask>
  <g mask="url(#mask0_371_48214)">
    <rect x="1" y="1" width="1" height="22" fill="black"/>
    <path d="M11.6615 2.33299C11.7127 2.2098 11.8873 2.2098 11.9385 2.33299L14.6215 8.78358C14.6431 8.83552 14.6919 8.871 14.748 8.8755L21.7119 9.4338C21.8449 9.44446 21.8988 9.61044 21.7975 9.69724L16.4917 14.2422C16.449 14.2788 16.4303 14.3362 16.4434 14.3909L18.0644 21.1866C18.0954 21.3164 17.9542 21.4189 17.8403 21.3494L11.8782 17.7078C11.8302 17.6784 11.7698 17.6784 11.7218 17.7078L5.75969 21.3494C5.64583 21.4189 5.50464 21.3164 5.5356 21.1866L7.15661 14.3909C7.16966 14.3362 7.151 14.2788 7.10828 14.2422L1.80248 9.69724C1.70115 9.61044 1.75508 9.44446 1.88808 9.4338L8.85204 8.8755C8.90811 8.871 8.95695 8.83552 8.97855 8.78358L11.6615 2.33299Z" stroke="black" stroke-width="1.5"/>
  </g>
</svg>
`;

function CustomerReviewView() {

  const [questions, setQuestions] = useState(reviewQuestions);
  const navigate = useNavigate();
  const [doneTabs, setDoneTabs] = useState([1]);
  const [activeTab, setActiveTab] = useState(1);
  const { showPleaseWait, closePleaseWait } = useContext(ModalAlertContext);
  const selectedQuestion = questions.find((question) => question.id === activeTab);
  const userAnswer = questions.find((question) => question.id === activeTab).userAnswer;

  const setRating = (id, rating) => {
    setQuestions((prev) => {
      const newQuestions = [...prev];
      newQuestions.find((question) => question.id === id).rating = rating;
      return newQuestions;
    });
  }

  const setUserAnswer = (id, answer) => {
    setQuestions((prev) => {
      const newQuestions = [...prev];
      newQuestions.find((question) => question.id === id).userAnswer = answer;
      return newQuestions;
    });
  }

  const handleNext = () => {
    setActiveTab(activeTab + 1);
    setDoneTabs([...doneTabs, activeTab + 1]);
  }

  const handleSubmit = async () => {
    const body = {
      slug: ChatStore.callState.slug,
      pin: ChatStore.callState.pin,
      ratings: questions.map((question) => ({
        comment: question.userAnswer,
        rating: question.rating,
      })),
    }
    await CallStore.sendCustomerReview(body);
    navigate("/customer/thanks");
  }

  return (
    <div className="customer-review-view">

      <img src={logoIcon} alt="customer-review" className="customer-review-view-logo" />

      <div className="customer-review-view-texts">
        <h1>{strings.howWasYourSupportSession}</h1>
        <p>{strings.pleaseTakeAMomentToShareYourFeedbackAboutTheRemoteSupportSession}</p>
      </div>

      <div className="customer-review-view-tabs">
        {questions.map((question) => (
          <div key={question.id} className={`customer-review-view-tab ${doneTabs.includes(question.id) ? "customer-review-view-tab-active" : ""}`}>
            <div className="customer-review-view-tab-number">
              <div>
                {question.id}
              </div>
            </div>
            <span className="customer-review-view-tab-title">{question.title}</span>
          </div>
        ))}
      </div>

      <div className="customer-review-view-additional-feedback">
        <span className="customer-review-view-additional-feedback-question">
          {selectedQuestion.question}
        </span>
        <h2>{strings.yourFeedback} <i>*</i> </h2>
        <textarea placeholder={strings.enterYourFeedbacks} value={userAnswer} onChange={(e) => setUserAnswer(selectedQuestion.id, e.target.value)} />
        <span className="customer-review-view-additional-feedback-character-count">{userAnswer.length}/1000</span>

        <div className="customer-review-view-additional-feedback-rating">
          {Array.from({ length: 5 }).map((_, index) => (
            <DomPurifyHtml
              onClick={() => setRating(selectedQuestion.id, index + 1)}
              className={`customer-review-view-additional-feedback-rating-star 
              ${selectedQuestion.rating >= index + 1 ? "customer-review-view-additional-feedback-rating-star-active" : ""}`}
              html={starSvgString}
            />
          ))}
        </div>
      </div>


      {activeTab < questions.length && (
        <button className="button-cta customer-review-view-next-button" onClick={handleNext} disabled={!selectedQuestion.rating}>
          <span>{strings.next}</span>
        </button>
      )}
      {activeTab === questions.length && (
        <button className="button-cta-secondary "
          onClick={handleSubmit}
          disabled={!selectedQuestion.rating}
        >
          <img src={submitIcon} alt="submit" />
          <span>{strings.submitFeedback}</span>
        </button>)}

    </div>
  );
}


export default observer(CustomerReviewView);